<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :selection="false"
      :columns="columns"
      :query="query"
      label-width="100px"
    />
  </div>
</template>

<script>
import { getFirstNowLastDay } from '@/utils/tool'
export default {
  name: 'Shiqitongji',
  components: {},
  data() {
    return {
      url: '/finance/statistical/time?view=STATION',
      columns: [
        {
          label: '时段',
          prop: 'createDate'
        },
        {
          label: '活跃用户数',
          prop: 'liveNum'
        },
        {
          label: '运营商',
          prop: 'orgName'
        },
        {
          label: '电量（度）',
          prop: 'totalPower',
          template: (index, record) => {
            return this.getFloat(record.totalPower)
          }
        },
        {
          label: '充电时长（小时）',
          prop: 'totalHour',
          template: (index, record) => {
            return this.getFloat(record.totalHour)
          }
        },
        {
          label: '电费（元）',
          prop: 'totalElecMoney',
          template: (index, record) => {
            return this.getFloat(record.totalElecMoney)
          }
        },
        {
          label: '服务费（元）',
          prop: 'totalServiceMoney',
          template: (index, record) => {
            return this.getFloat(record.totalServiceMoney)
          }
        },
        {
          label: '充电次数（次）',
          prop: 'totalTimes'
        },
        {
          label: '订单总金额（元）',
          prop: 'totalMoney',
          template: (index, record) => {
            return this.getFloat(record.totalMoney)
          }
        },
        {
          label: '用户实付（元）',
          prop: 'totalMoneyActual',
          template: (index, record) => {
            return this.getFixed2(record.totalMoneyActual)
          }
        }
      ],
      query: [
        {
          label: '开始日期',
          prop: 'startTime',
          placeholder: '请选择开始日期',
          type: 'date1',
          haveValue: true,
          data: this.getFirstNowLastDay(0)
        },
        {
          label: '结束日期',
          prop: 'endTime',
          placeholder: '请选择结束日期',
          type: 'date1',
          haveValue: true,
          data: this.getFirstNowLastDay(2)
        },
        // {
        //   label: "用户账号",
        //   prop: "loginName",
        //   placeholder: "请输入用户账号",
        // },
        {
          label: '运营商',
          prop: 'orgName',
          placeholder: '请输入运营商'
        },
        {
          label: '电桩名称',
          prop: 'equipmentName',
          placeholder: '请输入电桩名称'
        },
        {
          label: '电站名称',
          prop: 'stationName',
          placeholder: '请输入电站名称'
        }
      ]
    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    // 获取当前月起止日期
    getFirstNowLastDay(index) {
      const arr = getFirstNowLastDay()
      return arr[index]
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

  <style lang="less" src="" scoped></style>



// WEBPACK FOOTER //
// src/views/statistics/timeStationTotal.vue